import { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { doUpdatePreferences } from 'ducks/currentUser/operations'
import {
  selectCurrentUserPrefersInterestInChannelTwitter,
  selectCurrentUserPrefersInterestInChannelPhone,
  selectCurrentUserPrefersInterestInChannelSms,
  selectCurrentUserPrefersInterestInChannelWhatsapp,
} from 'ducks/currentUser/selectors/preferences'
import { AdminAccessDrawer } from 'subapps/settings/components/drawers/NoAccess'
import {
  paragraph,
  text,
} from '@groovehq/internal-design-system/lib/styles/elements'
import { CHANNEL_ADDITIONAL_TYPES } from 'subapps/settings/components/drawers/Channels/Channels.data'
import ModalBtns from '@groovehq/internal-design-system/lib/components/ModalBtns/ModalBtns'

import channelVoteTwitterImage from 'assets/integrations/channel-vote-twitter.png'
import channelVotePhoneImage from 'assets/integrations/channel-vote-phone.png'
import channelVoteSmsImage from 'assets/integrations/channel-vote-sms.png'
import channelVoteWhatsappImage from 'assets/integrations/channel-vote-whatsapp.png'

const AddChannelDrawer = ({ onExit, drawerChannelType }) => {
  const dispatch = useDispatch()
  const interesetInTwitterChannel = useSelector(
    selectCurrentUserPrefersInterestInChannelTwitter
  )
  const interesetInPhoneChannel = useSelector(
    selectCurrentUserPrefersInterestInChannelPhone
  )
  const interesetInSmsChannel = useSelector(
    selectCurrentUserPrefersInterestInChannelSms
  )
  const interesetInWhatsappChannel = useSelector(
    selectCurrentUserPrefersInterestInChannelWhatsapp
  )

  const dataMap = useMemo(
    () => ({
      twitter: {
        interested: interesetInTwitterChannel,
        key: 'interest_in_channel_twitter',
        image: channelVoteTwitterImage,
      },
      phone: {
        interested: interesetInPhoneChannel,
        key: 'interest_in_channel_phone',
        image: channelVotePhoneImage,
      },
      sms: {
        interested: interesetInSmsChannel,
        key: 'interest_in_channel_sms',
        image: channelVoteSmsImage,
      },
      whatsapp: {
        interested: interesetInWhatsappChannel,
        key: 'interest_in_channel_whatsapp',
        image: channelVoteWhatsappImage,
      },
    }),
    [
      interesetInTwitterChannel,
      interesetInPhoneChannel,
      interesetInSmsChannel,
      interesetInWhatsappChannel,
    ]
  )

  useEffect(
    () => {
      if (dataMap[drawerChannelType].interested) {
        return
      }

      dispatch(
        doUpdatePreferences(
          {
            [dataMap[drawerChannelType].key]: true,
          },
          {
            moduleOptions: {
              toasts: {
                enabled: false,
              },
            },
          }
        )
      )
    },
    [dispatch, dataMap, drawerChannelType]
  )

  const footer = (
    <ModalBtns tertiaryBtnText="Close" onClickTertiaryBtn={onExit} />
  )

  return (
    <AdminAccessDrawer
      title={CHANNEL_ADDITIONAL_TYPES[drawerChannelType].name}
      footer={footer}
      onClose={onExit}
    >
      <div className="grui flex flex-col flex-center pt-12 text-center">
        <img
          src={dataMap[drawerChannelType].image}
          alt="Unavailable"
          style={{ width: 160 }}
        />

        <p
          className="grui mt-12"
          css={[
            paragraph.styles.preflight,
            text.styles.textNormal,
            text.styles.fontMedium,
          ]}
        >
          Coming soon!
        </p>

        <p
          className="grui mt-5"
          css={[paragraph.styles.preflight, text.styles.textNormal]}
        >
          <>
            This channel isn't available yet. We're currently trying to get a
            feel for how many users would like to see this channel added.
          </>
        </p>

        <p
          className="grui mt-10"
          css={[paragraph.styles.preflight, text.styles.textNormal]}
        >
          <>
            For now, your name's been added to the list for when we launch this
            channel. We'll make sure to let you know when that is. Thank you for
            helping us shape our roadmap!
          </>
        </p>
      </div>
    </AdminAccessDrawer>
  )
}
export default AddChannelDrawer
